import { type CommentBbox } from "./bboxUtils";

interface SpotlightOverlayProps {
  bbox: CommentBbox;
}

const SPOTLIGHT_SCRIM = "rgba(0, 0, 0, 0.55)";

/**
 * Dims the artwork everywhere except the active comment's bounding box.
 * Four in-bounds scrim panels (not box-shadow) so the dimming is not
 * clipped by the scroll container's overflow.
 */
const PX = 100;
const ROUND = 6;

export function SpotlightOverlay({ bbox }: SpotlightOverlayProps) {
  const { x, y, w, h } = bbox;
  const leftPct = `${+(x * PX).toFixed(ROUND)}%`;
  const topPct = `${+(y * PX).toFixed(ROUND)}%`;
  const rightPct = `${+((x + w) * PX).toFixed(ROUND)}%`;
  const bottomPct = `${+((y + h) * PX).toFixed(ROUND)}%`;
  const widthPct = `${+(w * PX).toFixed(ROUND)}%`;
  const heightPct = `${+(h * PX).toFixed(ROUND)}%`;

  const scrimStyle = { backgroundColor: SPOTLIGHT_SCRIM };

  return (
    <div
      className="pointer-events-none absolute inset-0 z-[15]"
      data-testid="comment-spotlight-overlay"
      aria-hidden="true"
    >
      <div
        className="absolute"
        style={{ ...scrimStyle, left: 0, top: 0, right: 0, height: topPct }}
      />
      <div
        className="absolute"
        style={{ ...scrimStyle, left: 0, top: bottomPct, right: 0, bottom: 0 }}
      />
      <div
        className="absolute"
        style={{
          ...scrimStyle,
          left: 0,
          top: topPct,
          width: leftPct,
          height: heightPct,
        }}
      />
      <div
        className="absolute"
        style={{
          ...scrimStyle,
          left: rightPct,
          top: topPct,
          right: 0,
          height: heightPct,
        }}
      />
      <div
        className="border-white/80 pointer-events-none absolute rounded-sm border-2 shadow-[0_0_0_1px_rgba(0,0,0,0.35)] transition-all duration-300 ease-out"
        data-testid="comment-spotlight-hole"
        style={{
          left: leftPct,
          top: topPct,
          width: widthPct,
          height: heightPct,
        }}
      />
    </div>
  );
}
